import { render, staticRenderFns } from "./ansDistributionToRegForm.vue?vue&type=template&id=851aacd6&scoped=true&"
import script from "./ansDistributionToRegForm.vue?vue&type=script&lang=js&"
export * from "./ansDistributionToRegForm.vue?vue&type=script&lang=js&"
import style0 from "./ansDistributionToRegForm.vue?vue&type=style&index=0&id=851aacd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851aacd6",
  null
  
)

export default component.exports